module.exports = __webpack_public_path__ + "static/media/ig13.647c4a3b.jpg";